import { render, staticRenderFns } from "./FieldSelect.vue?vue&type=template&id=64c8e672"
import script from "./FieldSelect.vue?vue&type=script&lang=js"
export * from "./FieldSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports